<kendo-label
  [text]="labelName"
  class="input-label-header"
  [for]="formGroup"
></kendo-label>
<hr class="input-label-header-hr" />
<form [formGroup]="formGroup">
  <div class="form-check white-inputs" *ngFor="let inputOption of indication.inputOptions">
    <kendo-label
      class="form-check-label"
      [for]="radioOption"
      [text]="inputOption.displayName"
    ></kendo-label>
    <input
      class="form-check-input"
      type="radio"
      name="radioSelection"
      #radioOption
      [value]="inputOption.name"
      formControlName="radioSelection"
      kendoRadioButton
      (change)="updateSelections()"
    />
    <div *ngIf="inputOption.hasOwnProperty('checkbox') && enableCheckbox()" style="padding-left: 20px;">
      <div *ngFor="let checkbox of inputOption.checkbox">
        <input #childRadioGroup
          class="form-check-input"
          type="radio"
          name="checkboxSelection"
          #radioOption
          [value]="checkbox.name"
          formControlName="checkboxSelection"
          kendoRadioButton
          (change)="updateSelections()"
        />
        <kendo-label [for]="childRadioGroup" [text]="checkbox.displayName"></kendo-label>
        <!-- <input kendoCheckBox class="form-check-input" type="checkbox" [value]="checkbox.name" formControlName="checkboxSelection" (change)="updateSelections()" #radioCheckbox /> -->
        <!-- <kendo-label [for]="radioCheckbox" [text]="checkbox.displayName"></kendo-label> -->
      </div>
    </div>
  </div>
</form>
<br />
<button *ngIf="!hasCustomControlParent" kendoButton (click)="setDefaults()">Set Default Values</button>
